<template>
  <div>
    <list
      ref="list"
      unit="库存单据查询"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getBusinessDocList"
      @row-select="x => $emit('change', x)"
      @reset-query="$emit('reset-select')"
      @status-change="cellFun"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker size="mini" v-model.trim="params.StartTime" placeholder="请选择日期" value-format="yyyy-MM-dd" style="width: 180px"></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker size="mini" v-model.trim="params.EndTime" placeholder="请选择日期" value-format="yyyy-MM-dd" style="width: 180px"></el-date-picker>
        </el-form-item>
        <el-form-item label="单据类型">
          <el-select size="mini" v-model="params.billName" placeholder="请选择" @change="changeName" clearable>
            <el-option v-for="(item, index) in billList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号">
          <template slot-scope="{ row }">
            <el-link type="text">{{row.DocNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="DocDate" label="单据日期">
          <template slot-scope="{ row }">
            {{ $commonJs.toDateString(row.DocDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="BillName" label="单据类型" />
        <el-table-column prop="Status" label="单据状态" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" v-if="row.Status == 1" type="danger">未生效</el-tag>
            <el-tag size="mini" v-else-if="row.Status == 2" type="success">已生效</el-tag>
            <el-tag size="mini" v-else type="primary">草稿</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    
    <stock-dialog ref="stockDialog" :DisposeTax="1" />
    <orec-dialog ref="orecDialog"  />
    <prorec-dialog ref="prorecDialog"  />
    <outreturn-dialog ref="outreturnDialog"  />
    <preturn-dialog ref="preturnDialog"  />
    <out-dialog ref="outDialog"  />
    <mout-dialog ref="moutDialog"  />
    <mreturn-dialog ref="mreturnDialog"  />
    <allocation-dialog ref="allocationDialog"  />
    <sales-return-dialog ref="salesReturnDialog"  />
    <purchase-return-dialog ref="purchaseReturnDialog"  />
    <bill-dialog ref="billDialog"  />
    <oreturn-dialog ref="oreturnDialog"  />

  </div>
</template>
<script>
import listMixin from '@/mixins/list'
import list from '@/components/common/list'

import stockDialog from "@/components/purchase/business/stock/editDialog"; //进货单
import purchaseReturnDialog from "@/components/purchase/business/return/editDialog";//进货退货单
import billDialog from "@/components/sales/business/bill/editDialog";//销货单
import salesReturnDialog from "@/components/sales/business/return/editDialog";//销货退货单                 
import orecDialog from "@/components/stock/bismanage/orec/detailsDialog"; //其他入库单
import outDialog from "@/components/stock/bismanage/out/detailsDialog";//其他退库单
import oreturnDialog from "@/components/stock/bismanage/oreturn/detailsDialog";//其他入库退库单
import outreturnDialog from "@/components/stock/bismanage/outreturn/detailsDialog";//其他出库退库单
import allocationDialog from "@/components/stock/bismanage/allocation/detailsDialog";//调拨单
import prorecDialog from "@/components/stock/bismanage/prorec/detailsDialog";//产成品入库单
import preturnDialog from "@/components/stock/bismanage/preturn/detailsDialog";//产成品退库单
import moutDialog from "@/components/stock/bismanage/mout/detailsDialog";//材料出库单
import mreturnDialog from "@/components/stock/bismanage/mreturn/detailsDialog";//材料退库单

export default {
  mixins: [listMixin],
  components: { list,stockDialog,orecDialog,prorecDialog,outreturnDialog,
    preturnDialog,outDialog,moutDialog,mreturnDialog,allocationDialog,salesReturnDialog,
    purchaseReturnDialog,billDialog,oreturnDialog },
  data() {
    return {
      api: require('@/api/stock/stBook').default,
      wareApi: require('@/api/ba/warehouse').default,
      activeName: 0,
      wareList: [],
      params: {
        DocNo: '',
        DocDate: '',
        Status: null,
        billName: '',
        StartTime: this.$commonJs.getDayOffset(-30),
        EndTime: this.$commonJs.getDayOffset(0)
      },
      billList: [
        '进货单',
        '进货退货单',
        '销货单',
        '销货退货单',
        '其他入库单',
        '其他退库单',
        '其他出库单',
        '其他出库退库单',
        '调拨单',
        '产成品入库单',
        '产成品退库单',
        '材料出库单',
        '材料退库单'
      ]
    }
  },
  mounted() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      sessionStorage.setItem('ware', JSON.stringify(res.Data))
    })
  },
  methods: {
    changeName(e) {
      this.$refs.list.query()
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api.export(this.params).then(() => {
        loading.close()
      })
    },
    
    cellFun(row, column){
      console.log("🚀 ~ cellFun ~ row:", row.Status)
      // Status 0-草稿 1-未生效 2-已生效

      if (column.property == "DocNo") {
        switch (row.BillName) {
          case "进货单":
          sessionStorage.setItem("check", "1");
            this.$refs.stockDialog.openEditById(row.DocId);
            break;
          case "进货退货单":
          sessionStorage.setItem("check", "1");
            this.$refs.purchaseReturnDialog.openEditById(row.DocId);
            break;
          case "销货单":
          sessionStorage.setItem("check", "1");
            this.$refs.billDialog.openEditById(row.DocId); 
            break;
          case "销货退货单":
          sessionStorage.setItem("check", "1");
            this.$refs.salesReturnDialog.openEditById(row.DocId);
            break;
          case "其他入库单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.orecDialog.openEditById(row.DocId);
            }else{
              this.$refs.orecDialog.openDetailsById(row.DocId);
            }
            break;
          case "其他退库单": 
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.oreturnDialog.openEditById(row.DocId);
            }else{
              this.$refs.oreturnDialog.openDetailsById(row.DocId);
            }
            break;
          case "其他出库单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.outDialog.openEditById(row.DocId);
            }else{
              this.$refs.outDialog.openDetailsById(row.DocId);
            }
            break;
          case "其他出库退库单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.outreturnDialog.openEditById(row.DocId);
            }else{
              this.$refs.outreturnDialog.openDetailsById(row.DocId);
            }
            break;
          case "调拨单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.allocationDialog.openEditById(row.DocId);
            }else{
              this.$refs.allocationDialog.openDetailsById(row.DocId);
            }
            break;
          case "产成品入库单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.prorecDialog.openEditById(row.DocId);
            }else{
              this.$refs.prorecDialog.openDetailsById(row.DocId);
            }
            break;
          case "产成品退库单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.preturnDialog.openEditById(row.DocId);
            }else{
              this.$refs.preturnDialog.openDetailsById(row.DocId);
            }
            break;
          case "材料出库单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.moutDialog.openEditById(row.DocId);
            }else{
              this.$refs.moutDialog.openDetailsById(row.DocId);
            }
            break;
          case "材料退库单":
            if(row.Status != 2) {
              sessionStorage.setItem('check','1')
              this.$refs.mreturnDialog.openEditById(row.DocId);
            }else{
              this.$refs.mreturnDialog.openDetailsById(row.DocId);
            }
            break;
          default:
            this.$message.error("未知单据类型");
            break;
            
          // 此写法：跳转到销货单页面 搜索对应的单据并弹框
          // this.$router.push({
          //   name: "bill",
          //   params: {
          //     SourcePage:'库存成本台账',
          //     OrderId: row.SourceId,
          //     OrderNo: row.SourceNo,
          //     DocDate: row.DocDate,
          //     canWrite: this.$permission.canWrite()
          //   },
          // });
        }
      }
    }
  }
}
</script>
